/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import type { ReactNode } from "react";

import { spacing } from "../../../../../global/emotion";
import { useIsDesktopViewport } from "../../../../hooks/useIsDesktopViewport";
import { cssMediaQueryMinWidthTablet } from "../../../../lib/constants/emotionMediaQueries.constants";
import type { HallowElementProps } from "../../../../types/hallowElementProps.types";
import { Text } from "../../../_base/_core/Text/Text.emotion";

const containerStyle: Interpolation = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  paddingBottom: spacing.s,
  [cssMediaQueryMinWidthTablet]: {
    paddingBottom: spacing.none,
    paddingLeft: spacing.xl,
    paddingRight: spacing.l,
  },
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
  paddingTop: spacing.none,
  width: spacing.full,
};
const titleWrapperStyle: Interpolation = {
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  gap: spacing.m,
  padding: `${spacing.ms} 0`,
  [cssMediaQueryMinWidthTablet]: { padding: `${spacing.m} 0` },
};

export type PanelContentContainerProps = Omit<
  HallowElementProps<"div">,
  "title"
> & {
  title?: string;
  titleActionLeft?: ReactNode;
  titleActionRight?: ReactNode;
  headerCSS?: Interpolation;
};

export const PanelContentContainer = ({
  children,
  title,
  titleActionLeft,
  titleActionRight,
  headerCSS,
  ...props
}: PanelContentContainerProps) => {
  const isDesktop = useIsDesktopViewport();
  return (
    <div css={containerStyle} {...props}>
      <div css={[titleWrapperStyle, headerCSS]}>
        {titleActionLeft && titleActionLeft}
        {title && (
          <Text
            type={isDesktop ? "headline" : "title"}
            size={isDesktop ? "m" : "l"}
            as="h1"
          >
            {title}
          </Text>
        )}
        {titleActionRight && titleActionRight}
      </div>
      {children}
    </div>
  );
};
